import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { Toaster } from './components/ui/sonner';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import LanguageModal from './components/LanguageModal';
import PromoPopup from './components/PromoPopup';
import WhatsAppFloat from './components/WhatsAppFloat';
import QuickBook from './components/QuickBook';

// Public Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Offers from './pages/Offers';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

// Auth Pages
import Login from './pages/Login';
import Register from './pages/Register';

// Client Pages
import Booking from './pages/Booking';
import GiftCards from './pages/GiftCards';
import ClientAccount from './pages/ClientAccount';
import PaymentSuccess from './pages/PaymentSuccess';
import MobileBookBar from './components/MobileBookBar';

// Admin Pages
import AdminDashboard from './pages/AdminDashboard';

import './App.css';

const Layout = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <>
      {!isAdmin && <Navigation />}
      {!isAdmin && <LanguageModal />}
      {!isAdmin && location.pathname === '/' && <PromoPopup />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/offers" element={<Offers />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/book" element={<Booking />} />
        <Route path="/gift-cards" element={<GiftCards />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentSuccess />} />
        <Route
          path="/account"
          element={<ProtectedRoute><ClientAccount /></ProtectedRoute>}
        />
        <Route
          path="/admin"
          element={<ProtectedRoute requireAdmin><AdminDashboard /></ProtectedRoute>}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppFloat />}
      {!isAdmin && <QuickBook />}
      {!isAdmin && <MobileBookBar />}
      <Toaster position="bottom-right" />
    </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="App">
            <Layout />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
